export default __webpack_public_path__ + "static/media/biofit-builder-foundation-non-upholstered.1144aee6.png";